import React from "react";

// @material-ui/icons

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";

class UpdateProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      equalTo: "",
      currentPasswordState: "",
      newPasswordState: "",
      confirmNewPasswordState: "",
    };
    this.updateClick = this.updateClick.bind(this);
  }
  showNotification(place) {
    if (!this.state[place]) {
      var x = [];
      x[place] = true;
      this.setState(x);
      setTimeout(
        function() {
          x[place] = false;
          this.setState(x);
        }.bind(this),
        10000
      );
    }
  }
  updateClick() {
    if (this.state.currentPasswordState === "") {
      this.setState({ currentPasswordState: "error" });
    }
    if (this.state.newPasswordState === "") {
      this.setState({ newPasswordState: "error" });
    }
    if (this.state.confirmNewPasswordState === "") {
      this.setState({ confirmNewPasswordState: "error" });
    }
    // let user = Auth.currentAuthenticatedUser();
    // Auth.currentAuthenticatedUser()
    //   .then(user => {
    //     return Auth.changePassword(user, "oldPassword", "newPassword");
    //   })
    //   .then(data => console.log(data))
    //   .catch(err => console.log(err));
  }

  sendState() {
    return this.state;
  }
  // function that verifies if a string has a given length or not
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }
  compare(string1, string2) {
    if (string1 === string2) {
      return true;
    }
    return false;
  }
  change(event, stateName, type, stateNameEqualTo) {
    switch (type) {
      case "length":
        if (this.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "success" });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "password":
        if (this.verifyLength(event.target.value, 1)) {
          this.setState({ [stateName + "State"]: "success" });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "equalTo":
        if (this.compare(event.target.value, this.state[stateNameEqualTo])) {
          this.setState({ [stateName + "State"]: "success" });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      default:
        break;
    }
    this.setState({ [stateName]: event.target.value });
  }
  isValidated() {
    if (
      this.state.currentPasswordState === "success" &&
      this.state.newPasswordState === "success" &&
      this.state.confirmNewPasswordState === "success"
    ) {
      return true;
    } else {
      if (this.state.currentPasswordState !== "success") {
        this.setState({ currentPasswordState: "error" });
      }
      if (this.state.newPasswordState !== "success") {
        this.setState({ newPasswordState: "error" });
      }
      if (this.state.confirmNewPasswordState !== "success") {
        this.setState({ confirmNewPasswordState: "error" });
      }
    }
    return false;
  }
  render() {
    const { classes } = this.props;
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardBody>
              <form>
                <CustomInput
                  success={this.state.currentPasswordState === "success"}
                  error={this.state.currentPasswordState === "error"}
                  labelText="Current Password *"
                  id="currentPassword"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) =>
                      this.change(event, "currentPassword", "password"),
                    type: "password",
                  }}
                />
                <CustomInput
                  success={this.state.newPasswordState === "success"}
                  error={this.state.newPasswordState === "error"}
                  labelText="New Password *"
                  id="newPassword"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) =>
                      this.change(event, "newPassword", "password"),
                    type: "password",
                  }}
                />
                <CustomInput
                  success={this.state.confirmNewPasswordState === "success"}
                  error={this.state.confirmNewPasswordState === "error"}
                  labelText="Confirm New Password *"
                  id="confirmNewPassword"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) =>
                      this.change(
                        event,
                        "confirmNewPassword",
                        "equalTo",
                        "newPassword"
                      ),
                    type: "password",
                  }}
                />
                {/* <div className={classes.formCategory}>
                                    <small>(*)</small> <label>Required fields</label>
                                </div> */}
                <Button
                  color="secondary"
                  onClick={this.updateClick}
                  className={classes.registerButton}
                >
                  Update
                </Button>
              </form>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(notificationsStyle)(UpdateProfile);



// WEBPACK FOOTER //
// ./src/views/User/UpdatePassword.jsx